import { useContext, useEffect, useState } from "react";

import { CompanyTitledPage } from "../../TitledPage";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Pagination from "@mui/material/Pagination";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { grey } from '@mui/material/colors';
import { compareDataByPriceDetailId, getDisplaySize } from "../../../utils/Items";
import ErrorMessageBox from "../../../components/ErrorMessageBox";
import { IntegerFormControl } from "../../../components/FormControl";
import { inputValueToInt } from "../../../utils/utils";
import { TextField, Typography } from "@mui/material";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import DateInput from "../../../components/DateInput";

import { postBasePriceSearchInfoListAPI, postBasePriceUpdateInfoListAPI } from "../../../http/api/BasePriceAPI";
import { postMarketCalendarSearchNextOpenDateInfoAPI } from "../../../http/api/MarketCalendarAPI";

import { useLocation, useNavigate } from "react-router-dom";
import DeleteProductDialog from "../../product/DeleteProductDialog";
import AddProductDialog from "../../../components/dialog/addProductDialog/AddProductDialog";
import { MSG_ERR_BASIC_PRICE_INCORRECT, MSG_ERR_SHIPPING_DATE_NOT_ENTERED, MSG_ERR_SHIPPING_DATE_NOT_FOUND } from "../../../common/message";
import AddProductDetailMasterDialog from "../../../components/dialog/addProductDetailMasterDialog/AddProductDetailMasterDialog";
import AddProductMasterDialog from "../../../components/dialog/addProductMasterDialog/AddProductMasterDialog";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { confirmWhenChanged } from "../../../utils/validation";

// 価格表の行の最大数
const maxPriceTableRows = 20

// 価格表カラム名
const priceTableColumnNames = {
  display_order: "No",
  name: "商品", 
  place: "産地",
  other: "他",
  size: "発注規格",
  price: "価格",
  unit: "発注単位",
  loss: "入荷\n未定",
  show: "表示",
  remarks: "備考",
}

const priceTableColumnSx = {
  fontSize: 18
}

// 基本価格表編集遷移state取得
const getBasicPriceLocationState = (shippingDate) => ({shippingDate});

 // 表のデータ行1行分
function PriceTableRow({data, updateData, onClickAddProduct, onClickDeleteProduct,index}) {

  const setPriceValueInput = (value) => {
    updateData(data.infoListIndex, "basePriceInput", value);
  }

  const setPriceValidation = (isValid) => {
    updateData(data.infoListIndex, "validation", isValid);
  }

  const onChangeShotageInput = (event) => {
    const inputChecked = event.target.checked
    updateData(data.infoListIndex, "isShortage", inputChecked);
  }

  function onChangeIsCustomerOrder(event){
    const inputChecked = event.target.checked
    updateData(data.infoListIndex, "isCustomerOrder", inputChecked);
  }

  function onChangeIsOriginOther(event){
    const inputChecked = event.target.checked
    updateData(data.infoListIndex, "isOriginOther", inputChecked);
  }

  function onChangeRemarks(event){
    updateData(data.infoListIndex, "remarks", event.target.value);
  }

  const [focusing, setFocusing] = useState({
    tab: 1,
    item: "basePriceInput",
    index: -1,
  });

  function HandleFocus(event) {
    console.log(event.target.id);
    let id = event.target.id;
    let element = id.split("-");
    let tab = element[0];
    let cell = element[1];

    let patt1 = /[a-zA-Z]/g;
    let patt2 = /[0-9]/g;
    let letters = cell.match(patt1).join("");
    let digits = parseInt(cell.match(patt2).join(""));
    setFocusing({ tab, item: letters, index: digits });
  }

  function HandlePressKey(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      FocusNavigation(event.shiftKey);
    }
  }

  async function FocusNavigation(isPrevious = false) {
    let step = isPrevious ? -1 : 1;
    let nextItem;
    let nextStep = (focusing.index += step);
    let listPagingButton = document.getElementById(`paging`)
      .children[0].children;
    let nextPageButton =
      listPagingButton[listPagingButton.length - 1].children[0];
    let prevPageButton = listPagingButton[0].children[0];
    do {
      //次のページ行く
      if (nextStep >= maxPriceTableRows) {
        nextPageButton.focus();
        nextPageButton.click();
        nextStep = 0;
      }
      //前のページ戻る
      if (nextStep < 0) {
        prevPageButton.focus();
        prevPageButton.click();
        nextStep = maxPriceTableRows - 1;
      }
      await setTimeout(() => {}, 1000);
      nextItem = document.getElementById(
        `${focusing.tab}-${focusing.item + nextStep}`
      );
      nextStep += step;
    } while (nextItem.disabled);
    console.log(nextItem.id);
    nextItem.focus();
    nextItem.select();
  }
  
  function HandleKeyDown(event) {
    // console.log(event);
    if (event.ctrlKey) {
      if (event.key === "+") {
        event.preventDefault();
        document
          .getElementById(`${focusing.tab}-btnAddProduct${focusing.index}`)
          .click();
      }
      if (event.key === "-") {
        event.preventDefault();
        document
          .getElementById(`${focusing.tab}-btnDeleteProduct${focusing.index}`)
          .click();
      }
      if (event.key === "k") {
        event.preventDefault();
        updateData(data.infoListIndex, "isShortage", !data.isShortage);
        FocusNavigation();
      }
    }
  }
  return (
    <TableRow
    onFocus={HandleFocus}
    onKeyPress={HandlePressKey}
    onKeyDown={HandleKeyDown}
    >
      <TableCell sx={{ ...priceTableColumnSx }}>{data.displayOrder}</TableCell>
      <TableCell component="th" scope="row" sx={{...priceTableColumnSx, fontWeight: "bold", fontSize: 20, height:28, width:"18%"}}>
        {data.displayName}
      </TableCell>
      <TableCell sx={{...priceTableColumnSx, width:"8%"}}>{data.displayOrigin}</TableCell>
      <TableCell sx={{ ...priceTableColumnSx, width: "3%" }}>
        <Checkbox
          value={data.isOriginOther}
          onChange={onChangeIsOriginOther}
          checked={data.isOriginOther}
          id={`${data.priceDetailTypeId}-isOriginOther${index}`}
        />
        </TableCell> 
      <TableCell sx={{...priceTableColumnSx, width:"25%"}}>{data.displaySize}</TableCell>
      <TableCell sx={{...priceTableColumnSx, padding: 1, width: 100}}>
        <IntegerFormControl
          value={data.basePriceInput}
          setValue={setPriceValueInput}
          setValid={setPriceValidation}
          disabled = {data.isShortage || !data.isCustomerOrder}
          inputProps={{sx:{...priceTableColumnSx, textAlign:"right"}}} 
          inputSx={{width: 100}}
          helperTextSx={{margin:0, width: 100}}
          id={`${data.priceDetailTypeId}-basePriceInput${index}`}
        />
      </TableCell>
      <TableCell sx={{...priceTableColumnSx}}>{data.orderingUnit}</TableCell>
      <TableCell sx={{...priceTableColumnSx, padding: 1}}>
        <Checkbox
          onChange={onChangeShotageInput} checked={data.isShortage}
          id={`${data.priceDetailTypeId}-isShortage${index}`}
        />
      </TableCell>
      <TableCell sx={{ padding: 1 }}>
        <Checkbox
          onChange={onChangeIsCustomerOrder}
          checked={data.isCustomerOrder}
          id={`${data.priceDetailTypeId}-isCustomerOrder${index}`}
        />
      </TableCell>
      <TableCell sx={{ ...priceTableColumnSx, padding: 1 }}>
        <TextField
          value={data.remarks}
          onChange={onChangeRemarks}
          id={`${data.priceDetailTypeId}-remarks${index}`}
        ></TextField>
      </TableCell>
      <TableCell sx={{padding: 1}}>
        <Button variant="outlined" onClick={onClickAddProduct(data)} sx={{padding:1, minWidth:40, height:40, fontSize:30}} 
          id={`${data.priceDetailTypeId}-btnAddProduct${index}`}>+</Button>
      </TableCell>
      <TableCell sx={{padding: 1}}>
        <Button variant="outlined" color="error" onClick={onClickDeleteProduct(data)} sx={{padding:1, minWidth:40, height:40, fontSize:30}}
          id={`${data.priceDetailTypeId}-btnDeleteProduct${index}`}>-</Button>
      </TableCell>
    </TableRow>
  );
  
}

// 価格表(編集用)
function PriceEditTable({dataList, updateData, onClickAddProduct, onClickDeleteProduct}) {
      
  var lastName = "";
  var lastOrigin = "";

  if (dataList && dataList.length > 0) {
    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.display_order}
              </TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.name}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.place}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.other}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.size}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.price}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.unit}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.loss}</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>{priceTableColumnNames.show}</TableCell>
              <TableCell sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.remarks}
              </TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>追加</TableCell>
              <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100]}}>削除</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              dataList.map((data, i) => {
                let displayData = {
                  ...data,
                  displayName: (lastName === data.productName) ? "" : data.productName,
                  displayOrigin: (lastName === data.productName && lastOrigin === data.origin) ? "" : data.origin,
                }
 
                lastName = data.productName
                lastOrigin = data.origin

                return (
                  <PriceTableRow
                    data={displayData}
                    updateData = {updateData}
                    onClickAddProduct={onClickAddProduct}
                    onClickDeleteProduct={onClickDeleteProduct}
                    key={"basePrice_" + i.toString()}
                    index={i}
                  />
                )
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
    );
  }  
  
  return null;
}

// 価格表タブの内容
function PriceTableTabContent({dataList, updateDataList, onClickAddProduct, onClickDeleteProduct, tabPosition}) {

  const [page, setPage] = useState(1)

  const updateData = (basePriceDetailId, prop, value) => {
    updateDataList(basePriceDetailId, prop, value)
  }

  const handleChangeTablePage = (event, page_num) => {
    setPage(page_num)
  }

  //タブを変更するイベント
  useEffect(() => {
    setPage(1);
    console.log("tab change");
    //TODO React18のバッチアップデートを除く
    setTimeout(() => {
      try {
        //ページ１をクリック
        let listPagingButton =
          document.getElementById(`paging`).children[0].children;
        listPagingButton[1].children[0].click();

        //一番上対象にフォカス
        let topItem = `${tabPosition}-basePriceInput0`;
        document.getElementById(topItem).focus();
      } catch {}
    }, 500);
  }, [tabPosition]);

  var dataMinIndex = (page - 1) * maxPriceTableRows

  var tableData = dataList.slice(dataMinIndex, Math.min(dataMinIndex + maxPriceTableRows, dataList.length))

  return (
    <Box>
      <Grid container spacing={2} marginBottom={2}>
        <Grid item xs={12}>
          <PriceEditTable
            dataList={tableData}
            updateData={updateData}
            onClickAddProduct={onClickAddProduct}
            onClickDeleteProduct={onClickDeleteProduct}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Pagination
            count={Math.ceil(dataList.length / (maxPriceTableRows))}
            value={page} variant="outlined" shape="rounded"
            onChange={handleChangeTablePage}
            sx={{display: 'inline-block'}}
            id={`paging`}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

// 基本価格表ページ
export default function BasicPriceEditPage() {

  const location = useLocation();
  var initShippingDate = location.state ? location.state.shippingDate : null;

  const navigate = useNavigate();

  const [tableTabPosition, setTableTabPosition] = useState(1)  
  const [dialogMode, setDialogMode] = useState(0)

  const [basePriceInfoList, setBasePriceInfoList] = useState([]);

  const [selectedProductData, setSelectedProductData] = useState({
    basePriceDetailId: 0,
    productName: "",
    origin: "",
    rank: "",
    productClass: "",
    weight: "",
    weightUnit: "",
    orderingUnit: "",
    basePrice: 0,
    infoListIndex: 0
  })

  const [shippingDateInput, setShippingDateInput] = useState({
      date: "",
      initialized: false,
      cleared: ""
    });

  // 更新中をあらわすstate
  const [isUpdating, setUpdating] = useState(false);
  // 画面ステータスをcontextから取得
  const {isChanged, setChanged} = useContext(ScreenStatusContext);

  const getPriceTabDataList = (dataList, tabPosition) => {
    return dataList.filter((data) => data.priceDetailTypeId === tabPosition && !data.isDelete)
            .sort(compareDataByPriceDetailId)
  }
  
  useEffect(() => {
    (async () => {
      // 出荷日初期表示
      if (!initShippingDate) {
        let shippingDateRes = await postMarketCalendarSearchNextOpenDateInfoAPI({});
        initShippingDate = shippingDateRes.nextOpenDateInfo.nextOpenDate;
      }      

      setShippingDateInput({
        ...shippingDateInput,
        date: initShippingDate ? initShippingDate : "",
        initialized: true,
      });
      
      // 基本価格表データ取得
      let res = await postBasePriceSearchInfoListAPI({"basePriceId": 1});
      let infoList = res.basePriceInfoList.map((data, index) => ({
        ...data,
        displaySize: getDisplaySize(data.rank, data.productClass, data.weight, data.weightUnit, data.packing, data.quantity),
        basePriceInput: data.basePrice.toLocaleString(),
        validation: true,
        isDelete: false,
        isChanged: false,
        infoListIndex: index
      }));

      setBasePriceInfoList(infoList);
    })()
  }, [])

  const getErrorMessages = () => {
    let msgs = [];

    if (shippingDateInput.initialized && shippingDateInput.date.length === 0) {
      if (shippingDateInput.cleared) {
        msgs.push(MSG_ERR_SHIPPING_DATE_NOT_ENTERED);
      } else {
        msgs.push(MSG_ERR_SHIPPING_DATE_NOT_FOUND);
      }      
    }

    if (basePriceInfoList.some((productData) => (!productData.isDelete && !productData.validation))) {
      msgs.push(MSG_ERR_BASIC_PRICE_INCORRECT);
    }

    return msgs;
  }

  const handleChangeTab = (event, tabPos) => {
    setTableTabPosition(tabPos);
  };

  // 出荷日更新 
  const updateShippingDate = (shippingDate) => {
    let valueChanged = shippingDateInput.date !== shippingDate;

    setShippingDateInput({
      ...shippingDateInput,
      date: shippingDate,
      cleared: shippingDate.length === 0      
    });

    setChanged(isChanged || valueChanged); 
  }

  // 商品情報更新
  const updateDataList = (infoListIndex, prop, value) => {
      let newDataList = [...basePriceInfoList];
      let basePriceData = newDataList[infoListIndex];
      let valueChanged = basePriceData[prop] !== value;

      basePriceData[prop] = value;
      basePriceData.isChanged = true;

      setBasePriceInfoList(newDataList);
      setChanged(isChanged || valueChanged);      
  }

  // 商品追加ダイアログを開く
  const openAddProductDialog = (productData) => {
    setSelectedProductData(productData);
    setDialogMode(1);
  };

  // 商品追加ボタン押下時処理
  const onClickAddProduct = (productData) => (event) => {
    openAddProductDialog({
      productId: productData ? productData.productId : 0,
      productName: productData ? productData.productName : "",
      marketPrice: 0,
      displayOrder: productData ? productData.displayOrder : 0
    });
  };
  

  // 確定ボタン押下時処理
  const onClickConfirm = async (event) => {
    setUpdating(true);

    let updateInfoList = basePriceInfoList
        .filter((data) => (data.isChanged))
        .map((data) => ({
          basePriceId : data.basePriceId,
          basePriceDetailId : data.basePriceDetailId,
          priceDetailTypeId : data.priceDetailTypeId,
          productId : data.productId,
          productDetailId : data.productDetailId,
          basePrice : inputValueToInt(data.basePriceInput),
          isCustomerOrder: data.isCustomerOrder,
          isShortage: data.isShortage,
          remarks: data.remarks,
          displayOrder: data.displayOrder,
          isOriginOther: data.isOriginOther,
          isDelete : data.isDelete
        }));

    await postBasePriceUpdateInfoListAPI({
      basePriceUpdateInfoList: updateInfoList
    });

    navigate(SYSTEM_PATH_COMPANY + "/basic_price", {
      state: getBasicPriceLocationState(shippingDateInput.date)
    })
  }

  // 商品マスタ追加ダイアログを開く
  const openAddProductMasterDialog = (productData) => {
    setSelectedProductData(productData);
    setDialogMode(3);
  }

  // 商品明細マスタ追加ダイアログ
  const openAddProductDetailMasterDialog = (productData) => {
    setSelectedProductData(productData);
    setDialogMode(4);
  }  

  // 商品追加ダイアログを閉じる処理
  const onCloseDialog = (event) => {
    setDialogMode(0);
  }

  document.addEventListener("keydown", handleKeyDown);
  function handleKeyDown(e) {
    // console.log(e);
    if (e.key === "ArrowUp") {
      e.preventDefault();
      if (tableTabPosition > 1) {
        setTableTabPosition(tableTabPosition - 1);
      }
      console.log("move tab");
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (tableTabPosition < 3) {
        setTableTabPosition(tableTabPosition + 1);
      }
      console.log("move tab");
    }
  }

  
  // 商品を追加する処理
  const addProduct = (productData, part, price, displayOrder) => {
    const {
      productId,
      productDetailId,
      productName,
      origin,
      displaySize,
      unit,
    } = productData;

    let insertIndex = basePriceInfoList.findIndex(
      (productInfo, index) =>
        (productInfo.priceDetailTypeId == part &&
          productInfo.displayOrder >= displayOrder) ||
        productInfo.priceDetailTypeId > part
    );

    var insertBeforeList =
      insertIndex >= 0
        ? basePriceInfoList.slice(0, insertIndex)
        : basePriceInfoList;

    var insertAfterList = (
      insertIndex >= 0 ? basePriceInfoList.slice(insertIndex) : []
    ).map((productData) => ({
      ...productData,
      infoListIndex: productData.infoListIndex + 1,
      displayOrder:
        productData.priceDetailTypeId == part
          ? productData.displayOrder + 1
          : productData.displayOrder,
      isChanged: true,
    }));

    var insertDisplayOrder =
      insertBeforeList
        .filter(
          (productData) =>
            productData.priceDetailTypeId == part && !productData.isDelete
        )
        .map((productData) => productData.displayOrder)
        .reduce((a, b) => Math.max(a, b), 0) + 1;

    const newBasePriceInfo = {
      ...productData,
      //TODO 基本価格表登録性能次第　デフォルト値　１の基本価格表データを取得
      basePriceId: 1,
      priceDetailTypeId: part,
      basePrice: price,
      rank: displaySize,
      isShortage: false,
      isOriginOther: false,
      basePriceInput: price.toLocaleString(),
      validation: true,
      isDelete: false,
      isChanged: true,
      isCustomerOrder: true,
      remarks: "",
      infoListIndex:
        insertIndex >= 0 ? insertIndex : basePriceInfoList.length,
      displayOrder: insertDisplayOrder,
    };

    var newInfoList = [
      ...insertBeforeList,
      newBasePriceInfo,
      ...insertAfterList,
    ];

    setBasePriceInfoList(newInfoList);
    setChanged(true);
  };

  const onClickDeleteProduct = (productData) => (event) => {
    setSelectedProductData(productData);
    setDialogMode(2);
  }

  const deleteProductData = () => {
    var deleteIndex = selectedProductData.infoListIndex;

    var newInfoList = [...basePriceInfoList].map(
      (productData, productIndex) => ({
        ...productData,
        displayOrder:
          productIndex > deleteIndex &&
          productData.priceDetailTypeId == selectedProductData.priceDetailTypeId
            ? productData.displayOrder - 1
            : productData.displayOrder,
        isDelete: productIndex == deleteIndex || productData.isDelete,
        isChanged:
          (productIndex >= deleteIndex &&
            productData.priceDetailTypeId ==
              selectedProductData.priceDetailTypeId) ||
          productData.isChanged,
      })
    );

    setBasePriceInfoList(newInfoList);
    setChanged(true);
  }

  // 「戻る」押下
  const onClickReturn = (event) => {
    if (confirmWhenChanged(isChanged)) {
      navigate(SYSTEM_PATH_COMPANY + "/basic_price")
    }
  };

  return (
    <CompanyTitledPage title="基本価格表　編集">

      <ErrorMessageBox messages={getErrorMessages()} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Typography sx={{fontSize: 20, textAlign: "right"}}>
            出荷日 : 
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <DateInput
            value={shippingDateInput.date}
            setValue={updateShippingDate}
          />
        </Grid>
      </Grid>

      <Box marginTop={2} marginBottom={2}>
        <Grid container alignItems='baseline' spacing={2}>
          <Grid item xs>
            <Tabs value={tableTabPosition} onChange={handleChangeTab}>
              <Tab label="蔬菜" value={1} />
              <Tab label="果物" value={2} />
              <Tab label="スポット" value={3} />
            </Tabs>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" color="error" onClick={onClickAddProduct(null)}>商品追加</Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickConfirm} disabled={isUpdating}>基本価格表確定</Button>
          </Grid>
          <Grid item xs="auto">
            <Button size="medium" variant="outlined"
              onClick={onClickReturn}>戻る</Button>
          </Grid>
        </Grid>
      </Box>
      
      <Box>
        <PriceTableTabContent
          dataList = {getPriceTabDataList(basePriceInfoList, tableTabPosition)}
          updateDataList = {updateDataList}
          onClickAddProduct = {onClickAddProduct}
          onClickDeleteProduct = {onClickDeleteProduct}
          tabPosition={tableTabPosition}
        />
      </Box>

      <AddProductDialog
        open={dialogMode === 1}
        tabPosition={tableTabPosition}
        productData={selectedProductData}
        onClose={onCloseDialog}
        addProduct={addProduct}
        priceTitle="基本価格"
        openAddProductMasterDialog={openAddProductMasterDialog}
        openAddProductDetailMasterDialog={openAddProductDetailMasterDialog}
        addedProductList={basePriceInfoList.filter(
          (data) =>
            !data.isDelete
        )}
      />
      <DeleteProductDialog
        open={dialogMode === 2}
        tabPosition={tableTabPosition}
        productData={selectedProductData}
        onCloseDialog={onCloseDialog}
        deleteProductData={deleteProductData}
      />
      
      <AddProductMasterDialog
        open={dialogMode === 3}
        onClose={onCloseDialog}
        productData={selectedProductData}
        openAddProductDialog={openAddProductDialog}
        openAddProductDetailMasterDialog={openAddProductDetailMasterDialog} 
      />

      <AddProductDetailMasterDialog
        open={dialogMode === 4}
        onClose={onCloseDialog}
        productData={selectedProductData}
        openAddProductDialog={openAddProductDialog}
      />

    </CompanyTitledPage>
  );
}
